import { lazy } from 'react';

import { ALLOWED_ROLES } from 'packages/utils';

import { PATHS } from './constants';
import { ScheduleListProvider } from './screens/SchedulesList/context';

const SchedulesList = lazy(() => import('./screens/SchedulesList'));
const Schedule = lazy(() => import('./screens/Schedule'));

const routesRoutes = [
  {
    component: () => (
      <ScheduleListProvider>
        <SchedulesList />
      </ScheduleListProvider>
    ),
    path: PATHS.BASE_URL,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.SCHEDULES.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: Schedule,
    path: PATHS.EDIT_SCHEDULE,
    overlay: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.SCHEDULES.UPDATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: Schedule,
    path: PATHS.CREATE_SCHEDULE,
    overlay: true,
    writeOnly: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.SCHEDULES.CREATE,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
];

export default routesRoutes;
